import { render, staticRenderFns } from "./EditSalesInvoice.vue?vue&type=template&id=fd124f46"
import script from "./EditSalesInvoice.vue?vue&type=script&lang=ts"
export * from "./EditSalesInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports